
document.addEventListener("DOMContentLoaded", function() {
  // Get the current page URL
  var currentUrl = window.location.href;

  // Identify the main category based on the URL
  var mainCategory = null;

  if (currentUrl.includes("/collections/eyes")) {
    mainCategory = "eyes";
  } else if (currentUrl.includes("/collections/lashes")) {
    mainCategory = "lashes";
  } else if (currentUrl.includes("/collections/lips")) {
    mainCategory = "lips";
  } else if (currentUrl.includes("/collections/face")) {
    mainCategory = "face";
  } else if (currentUrl.includes("/collections/nails")) {
    mainCategory = "nails";
  } else if (currentUrl.includes("/collections/nail-tips-accessories")) {
    mainCategory = "nail-tips-accessories";
  } else if (currentUrl.includes("/collections/brushes-tools")) {
    mainCategory = "brushes-tools";
  }

  // Expand the main category in the menu if it exists
  if (mainCategory !== null) {
    var categoryElement = document.querySelector('.c-menu_item[data-link="' + mainCategory + '"]');
    if (categoryElement) {
      var parentMenu = categoryElement.closest('.collapse-menu-item');
      parentMenu.classList.add("active"); // Apply a CSS class to indicate active state
      var subMenu = parentMenu.querySelector('.customer-service-menu');
      if (subMenu) {
        subMenu.style.display = "block"; // Display the sub-menu
      }
    }
  }
});
